import router, { useRouter } from "next/router";
import { useEffect } from "react";

import { PageLoading } from "common/ui/PageLoading";

import { getCode } from "common/features/signs/api/getCode";

export default function QrCodePage() {
  const { query, isReady } = useRouter();

  useEffect(() => {
    if (!isReady) return;

    getCode(query.qrCode as string)
      .then(res => {
        const locale = res.language.toString() === "english" ? "en-US" : "fr";

        if (res.associatedListingId) {
          location.href = `${process.env.NEXT_PUBLIC_MARKETPLACE_URL}/${locale}/properties/${res.associatedListingId}`;
          return;
        }

        if (res.associatedUserId) {
          location.href = `${process.env.NEXT_PUBLIC_SELLER_URL}/${locale}/sales/signs`;
          return;
        }

        location.href = `${process.env.NEXT_PUBLIC_SELLER_URL}/${locale}/sales/signs?qrCode=${query.qrCode}&addNewCode=true`;
      })
      .catch(err => {
        if (err.status === 404) {
          router.push("/not-found");
          return;
        }

        router.push("/error");
      });
  }, [isReady]);

  return <PageLoading />
}
